// Mobile sticky add-to-cart bar: visible only once the main add button has scrolled above the viewport.
class StickyBuy extends HTMLElement {
  #observer;

  connectedCallback() {
    const scope = this.closest('s-product-form') ?? this.parentElement;
    const target = this.dataset.target ? scope?.querySelector(this.dataset.target) : null;
    if (!target) return;

    // Only reveal after the shopper has scrolled past the main button, so they have seen the size picker.
    this.#observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', show);
      this.inert = !show;
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', StickyBuy);
